import React, { useEffect } from "react";
import {
  AddButton,
  DownloadButton,
  TopHeading,
  Wrapper,
} from "../../../common/index.style";
import PublisherDataTableAG from "../../../components/table/PublisherDataTableAG";
import { DataContent } from "./index.style";
import { useDispatch, useSelector } from "react-redux";
import { getAllPublishers } from "../../../redux/publisherSlice";
import { CSVLink } from "react-csv";
import { csvPublisherData } from "../../../utils/helper";
import { Row, Col, Space } from "antd";

const Publishers = () => {
  const dispatch = useDispatch();
  const store = useSelector((store) => store);

  useEffect(() => {
    dispatch(getAllPublishers());
  }, []);

  const { allPublisers, loading } = store?.publisher;

  const data = csvPublisherData(allPublisers ?? []);

  return (
    <Wrapper>
      <Row justify="space-between" align="middle" style={{ marginBottom: 24 }}>
        <Col>
          <TopHeading style={{ margin: 0 }}>Publishers</TopHeading>
        </Col>
        <Col>
          <Space size="middle">
            <AddButton to="/publisher/add">Add Publisher</AddButton>
            <CSVLink filename="publishers" data={data}>
              <DownloadButton>Download</DownloadButton>
            </CSVLink>
          </Space>
        </Col>
      </Row>
      <DataContent>
        <PublisherDataTableAG publishers={allPublisers} loading={loading} />
      </DataContent>
    </Wrapper>
  );
};

export default Publishers;
